import React from 'react';
import { Box } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import colors from 'src/utils/colors';

export const LibraryTableHeader: React.FC = () => {
  return (
    <Box sx={{ padding: '0 16px 0 16px', marginBottom: '16px' }}>
      <Flex gap={64} alignItems="center">
        <Box sx={{ width: '429px' }}>
          <Text
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 700,
              lineHeight: '20px',
              color: colors.darkBlue,
              letterSpacing: '1.2px',
              textTransform: 'uppercase'
            }}
          >
            PRODUCTS
          </Text>
        </Box>
        <Box sx={{ width: '94px' }}>
          <Text
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 700,
              lineHeight: '20px',
              color: colors.darkBlue,
              letterSpacing: '1.2px',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap'
            }}
          >
            RETAILER SKU
          </Text>
        </Box>
        <Box sx={{ width: '189px' }}>
          <Text
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 700,
              lineHeight: '20px',
              color: colors.darkBlue,
              letterSpacing: '1.2px',
              textTransform: 'uppercase'
            }}
          >
            LAST UPDATED BY
          </Text>
        </Box>
        <Box>
          <Text
            variant="body2"
            sx={{
              fontSize: '12px',
              fontWeight: 700,
              lineHeight: '20px',
              color: colors.darkBlue,
              letterSpacing: '1.2px',
              textTransform: 'uppercase'
            }}
          >
            VERSIONS
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
